import type { AddressInfo } from 'node:net';
import { createRequire } from 'node:module';
import { join } from 'node:path';
import { pathToFileURL } from 'node:url';
import { readPackageJson } from '@wix/cli-fs';

const EXTENSIONS_PACKAGE = '@wix/custom-extensions';
const EXTENSIONS_PACKAGE_NODE_API = `${EXTENSIONS_PACKAGE}/node`;

interface ExtensionsDevServer {
  address: AddressInfo;
  stop: () => Promise<void>;
}

export async function isStandaloneExtensionsProject(projectFolder: string) {
  const packageJson = await readPackageJson(projectFolder);
  const projectDependencies = {
    ...packageJson.dependencies,
    ...packageJson.devDependencies,
  };

  return Object.hasOwn(projectDependencies, EXTENSIONS_PACKAGE);
}

export async function importExtensionsPackageNodeApi(
  projectFolder: string
): Promise<{
  build: (options: { rootDir: string }) => Promise<{ metadata: unknown }>;
  dev: (options: {
    allowedHosts?: string[];
    base?: string;
    port?: number;
    rootDir: string;
  }) => Promise<ExtensionsDevServer>;
  generateFallbackManifest: (options: {
    rootDir: string;
  }) => Promise<{ metadata: unknown }>;
}> {
  const require = createRequire(join(projectFolder, 'package.json'));
  const packageEntry = require.resolve(EXTENSIONS_PACKAGE_NODE_API);

  return import(pathToFileURL(packageEntry).href);
}
